<template>
  <div v-if="value.academicYear" class="light-gray-container">
    <div class="row white-container">
      <!-- col 1 -->
      <div class="col-12 col-md pb-3 pb-md-0">
        <div class="row">
          <div class="col-1">
            <i class="orange-icon fal fa-calendar-edit" />
          </div>
          <div class="col-10 d-flex flex-column">
            <label>Año Académico:</label>
            <span>
              {{ value.academicYear.name }}
            </span>
          </div>
        </div>
      </div>

      <!-- col 3 -->
      <div class="col-12 col-md pb-3 pb-md-0">
        <div class="row">
          <div class="col-1">
            <i class="orange-icon fal fa-clipboard-list-check" />
          </div>
          <div class="col-10 d-flex flex-column">
            <label>Municipio:</label>
            <span>
              {{ value.municipality.name }}
            </span>
          </div>
        </div>
      </div>

      <!-- col 4 -->
      <div class="col-12 col-md pb-3 pb-md-0">
        <div class="row">
          <div class="col-1">
            <i class="orange-icon fal fa-clipboard-list-check" />
          </div>
          <div class="col-10 d-flex flex-column">
            <label>Escuela:</label>
            <span>
              {{ value.school.name }}
            </span>
          </div>
        </div>
      </div>

      <!-- col 2 -->
      <div class="col-12 col-md pb-3 pb-md-0">
        <div class="row">
          <div class="col-1">
            <i class="orange-icon fal fa-clipboard-list-check" />
          </div>
          <div class="col-10 d-flex flex-column">
            <label>Categoría de la Alternativa:</label>
            <span>{{ value.alternativeId }} - {{ value.category.name }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row white-container">
      <!-- col 5 -->
      <div class="col-12 col-md-3 pb-1 pb-md-0">
        <div class="row">
          <div class="col-1">
            <i class="orange-icon fal fa-clipboard-list-check" />
          </div>
          <div class="col-10 d-flex flex-column">
            <label>Nombre de la Alternativa:</label>
            <span class="text-capitalize">
              {{ value.alternative?.name | empty }}
            </span>
          </div>
        </div>
      </div>

      <!-- col 3 -->
      <div class="col-12 col-md-3 pb-3 pb-md-0">
        <div class="row">
          <div class="col-1">
            <i class="orange-icon fal fa-file-exclamation" />
          </div>
          <div class="col-10 d-flex flex-column">
            <label>Especialidad de Salón:</label>
            <span>
              {{ value?.salonSpeciality?.name | empty }}
            </span>
          </div>
        </div>
      </div>

      <!-- col 4 -->
      <div class="col-12 col-md-3 pb-3 pb-md-0">
        <div class="row">
          <div class="col-1">
            <i class="orange-icon fal fa-clipboard-user" />
          </div>
          <div class="col-10 d-flex flex-column">
            <label>Cupo:</label>
            <span>
              {{ value?.studentCapacity | empty }}
            </span>
          </div>
        </div>
      </div>

      <!-- col 5 -->
      <div class="col-12 col-md-3 pb-3 pb-md-0">
        <div class="row">
          <div class="col-1">
            <i class="orange-icon fal fa-clipboard-user" />
          </div>
          <div class="col-10 d-flex flex-column">
            <label>Conteo Asistente:</label>
            <span>
              {{ formattedAssistantCount }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InformationHeader',
  components: {},
  props: {
    value: {
      type: null,
      required: true,
    },
  },
  computed: {
    assistantCount() {
      return this.value?.assistants?.totalItemCount || 0;
    },
    formattedAssistantCount() {
      return this.assistantCount.toString().padStart(2, '0');
    },
  },
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@import '@/assets/scss/variables/_colors.scss';

.orange-icon {
  color: map.get($colors, 'orange') !important;
  font-weight: bold;
  font-size: 1.125rem;
}

.light-gray-container {
  background: map.get($colors, 'gray-9');
  border-radius: 5px;
  padding: 10px 25px;
}

.white-container {
  background: map.get($colors, 'white');
  border-radius: 5px;
  padding: 10px 20px;
}

.white-container label {
  font-size: 0.875rem;
  color: map.get($colors, 'gray-6');
}

.white-container span {
  font-size: 1rem;
  font-weight: normal;
  color: map.get($colors, 'black');
}
</style>
